import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAgentAuth } from '../../context/AgentAuthContext';

export default function AgentRoute() {
  const { isAuthenticated, loading } = useAgentAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-teal-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/agent/login" replace />;
  }

  return <Outlet />;
}
